import { useEffect, useRef } from "react";
import { useObserverStore } from "../../stores/observerStore";

const TYPE_COLORS: Record<string, string> = {
	"agent-registered": "#bb9af7",
	trade: "#e0af68",
	"travel-started": "#7aa2f7",
	"travel-arrived": "#73daca",
	"galactic-event": "#ff9e64",
};

export function EventFeed(): React.JSX.Element {
	const eventLog = useObserverStore((s) => s.eventLog);
	const scrollRef = useRef<HTMLDivElement>(null);

	// Auto-scroll to bottom on new events
	useEffect(() => {
		if (scrollRef.current) {
			scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
		}
	});

	return (
		<div
			style={{
				position: "absolute",
				bottom: "12px",
				right: "12px",
				width: "320px",
				maxHeight: "220px",
				background: "rgba(10, 10, 15, 0.85)",
				backdropFilter: "blur(8px)",
				border: "1px solid rgba(26, 26, 46, 0.8)",
				borderRadius: "6px",
				overflow: "hidden",
				zIndex: 20,
				fontFamily: "'JetBrains Mono', 'Fira Code', monospace",
				fontSize: "0.65rem",
				display: "flex",
				flexDirection: "column",
			}}
		>
			<div
				style={{
					padding: "0.4rem 0.6rem",
					borderBottom: "1px solid rgba(26, 26, 46, 0.8)",
					color: "#565680",
					fontSize: "0.6rem",
					textTransform: "uppercase",
					letterSpacing: "0.1em",
				}}
			>
				Event Log
			</div>

			<div
				ref={scrollRef}
				style={{
					overflowY: "auto",
					padding: "0.3rem 0.6rem",
					flex: 1,
				}}
			>
				{eventLog.length === 0 ? (
					<div style={{ color: "#333", padding: "0.5rem 0", textAlign: "center" }}>
						Waiting for events...
					</div>
				) : (
					eventLog.map((event, i) => (
						<div
							key={`${event.timestamp}-${i}`}
							style={{
								padding: "0.15rem 0",
								color: "#c8c8d0",
								borderLeft: `2px solid ${TYPE_COLORS[event.type] ?? "#565680"}`,
								paddingLeft: "0.4rem",
								marginBottom: "0.15rem",
							}}
						>
							<span style={{ color: "#565680" }}>
								{new Date(event.timestamp).toLocaleTimeString([], { hour12: false })}
							</span>{" "}
							{event.message}
						</div>
					))
				)}
			</div>
		</div>
	);
}
